import { useCallback, useEffect, useState } from 'react';
import { ReferralSources } from './ReferralSources';
import { PeoplePerformance } from './PeoplePerformance';
import { Leaderboard } from './leaderboard/Leaderboard';
import { useAutoRefresh } from '../../hooks/useAutoRefresh';

const iso = (d) => d.toLocaleDateString('en-CA');
const periodDates = (p) => {
  const t = new Date();
  if (p === 'week') return { date_from: iso(new Date(t.getFullYear(), t.getMonth(), t.getDate() - ((t.getDay() + 6) % 7))), date_to: '' };
  if (p === 'month') return { date_from: iso(new Date(t.getFullYear(), t.getMonth(), 1)), date_to: '' };
  return { date_from: '', date_to: '' };
};

export const ReferralsCenter = ({ authFetch, apiUrl, canEdit }) => {
  const [sources, setSources] = useState([]);
  const [perf, setPerf] = useState(null);
  const [board, setBoard] = useState(null);
  const [period, setPeriodState] = useState('month');
  const [f, setFState] = useState({ type: '', code: '', college: '', ...periodDates('month') });

  const api = useCallback(async (path, opts = {}, wantError = false) => {
    const res = await authFetch(`${apiUrl}/api/admin/referrals${path}`, { ...opts, headers: { 'Content-Type': 'application/json' } });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return wantError ? { error: typeof data.detail === 'string' ? data.detail : 'Something went wrong' } : null;
    return data;
  }, [authFetch, apiUrl]);

  const setPeriod = (p) => { setPeriodState(p); setFState((x) => ({ ...x, ...periodDates(p) })); };
  const setF = (next) => {
    if (next.date_from !== f.date_from || next.date_to !== f.date_to) setPeriodState('custom');
    setFState(next);
  };

  const loadSources = useCallback(() => api('/sources').then((d) => d && setSources(d.sources)), [api]);
  const loadPerf = useCallback(() => {
    const qs = new URLSearchParams(Object.fromEntries(Object.entries(f).filter(([, v]) => v)));
    api(`/performance?${qs}`).then((d) => d && setPerf(d));
    const dq = new URLSearchParams(Object.fromEntries(Object.entries({ date_from: f.date_from, date_to: f.date_to }).filter(([, v]) => v)));
    api(`/leaderboard?${dq}`).then((d) => d && setBoard(d));
  }, [api, f]);

  const [updatedAt, setUpdatedAt] = useAutoRefresh(useCallback(() => { loadSources(); loadPerf(); }, [loadSources, loadPerf]));
  useEffect(() => { loadSources(); }, [loadSources]);
  useEffect(() => { loadPerf(); setUpdatedAt(new Date()); }, [loadPerf, setUpdatedAt]);

  return (
    <div className="space-y-5" data-testid="referrals-center">
      <div>
        <h2 className="font-outfit text-2xl font-bold text-[#0b1f4d]">Referrals &amp; Outreach</h2>
        <p className="text-sm text-slate-500">Who brought each student in, and how far those students have got. Follow-ups for each student are in the Student Engagement tab.</p>
      </div>
      <Leaderboard data={board} period={period} setPeriod={setPeriod} dates={f} updatedAt={updatedAt} />
      <PeoplePerformance data={perf} f={f} setF={setF} sources={sources} />
      <ReferralSources sources={sources} api={api} authFetch={authFetch} apiUrl={apiUrl} canEdit={canEdit} onChanged={() => { loadSources(); loadPerf(); }} />
    </div>
  );
};
